import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Icon, UiButton } from '@shared/ui';

import s from './Warehouse.module.css';
import { sendCreateInventoryRequest } from '../../store/slices/boardSlice';
import { getWarehouseTotalInfoRequest } from '../../store/slices/warehouseTotalInfoSlice';

export const WarehouseFooter = ({ warehouseData }) => {
    const dispatch = useDispatch();
    const isAddInventoryButtonDisable = useSelector(
        (state) => state.inventory.isAddInventoryButtonDisable
    );
    const hasFullAccess = useSelector((state) => state.restrictions);

    return (
        <div className={s.warehouseFooter}>
            {hasFullAccess && (
                <button
                    className={s.warehouseButton}
                    data-id="create-inventory-button"
                    onClick={() => {
                        dispatch(sendCreateInventoryRequest(warehouseData.id));
                        dispatch(getWarehouseTotalInfoRequest(warehouseData.id));
                    }}
                    disabled={isAddInventoryButtonDisable}
                    type="submit"
                >
                    <span className={s.warehouseButtonPlus} />
                </button>
            )}
        </div>
    );
};
